// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardSort_wrapper__2VA9W","select":"DashboardSort_select__3jLDZ"};